import React from "react";

const Serology = () => {
  return (
    <div>
      {/* Add your component content here */}
      <h1>Serology Component</h1>
    </div>
  );
};

export default Serology;
